import { getModuleName } from 'user/OhsUserServices';
import { ModuleType } from 'global-services/constants/OhsObject';

import { OhsUser } from '../../user/OhsUser';
import OhsBreadcrumbsNameAndRef from './OhsBreadcrumbsNameAndRef';

const OhsBreadcrumbExport = (
  ohsBreadcrumbsNameAndRef: OhsBreadcrumbsNameAndRef,
  modulePath: string,
  subPath: string,
  operationPath: string,
  user: OhsUser
) => {
  const defaultModule = {
    name: getModuleName(user.configs, ModuleType.Export),
    href: `/${modulePath}/home`,
  };

  if (subPath === 'home') {
    ohsBreadcrumbsNameAndRef.leafName = {
      name: defaultModule.name,
    };
  } else if (operationPath.indexOf('details') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = defaultModule;
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Details' };
  }

  return ohsBreadcrumbsNameAndRef;
};

export default OhsBreadcrumbExport;
